// extracted by mini-css-extract-plugin
export var deleteModal = "_gk-0";